import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Error } from "@progress/kendo-react-labels";
import areas from "../messages/Areas.json";

export const NewForm = props => {

    return <Dialog title={`New Route `} onClose={props.cancelNew}>
        <Form onSubmit={props.onSubmit} initialValues={props.item} render={formRenderProps => <FormElement style={{
            maxWidth: 650
        }}>
            <fieldset className={"k-form-fieldset"}>
                <div className="mb-3">
                    <Field
                        name={"routeName"}
                        id={"routeName"}
                        component={Input}
                        label={"Name"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"area"}
                        id={"area"}
                        component={DropDownList}
                        data={areas}
                        dataItemKey={"id"}
                        textField={"areaName"}
                        label={"Areas"}
                    />
                </div> 
                <div className="mb-3">
                    <Field
                        name={"routeDestination"}
                        id={"routeDestination"}
                        component={Input}
                        label={"Destination"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"routeActive"}
                        id={"routeActive"}
                        component={Checkbox}
                        label={"Active"}
                    />
                </div>
                <div className="mb-3">
                    <p></p>
                </div>
            </fieldset>
            <div className="k-form-buttons">
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" disabled={!formRenderProps.allowSubmit}>
                    Update
                </button>
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={props.cancelNew}>
                    Cancel
                </button>
            </div>
        </FormElement>} />
    </Dialog>;
}; 